import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import '../styles/CookieConsent.css'
import { useTranslation } from '../context/LanguageContext.jsx'

const STORAGE_KEY = 'deverse_cookie_consent'

const CookieConsent = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true)
      }
    } catch {
      setVisible(true)
    }
  }, [])

  const save = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value)
    } catch {
      /* ignore */
    }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="cookie-consent-inner">
        <div className="cookie-consent-text">
          <h2 id="cookie-consent-title" className="cookie-consent-title">
            {t('cookie.title')}
          </h2>
          <p id="cookie-consent-desc" className="cookie-consent-desc">
            {t('cookie.bodyBeforeLink')}{' '}
            <Link to="/privacy-policy">{t('cookie.link')}</Link>
            {t('cookie.bodyAfterLink')}
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button type="button" className="cookie-btn cookie-btn--ghost" onClick={() => save('essential')}>
            {t('cookie.essential')}
          </button>
          <button type="button" className="cookie-btn cookie-btn--primary" onClick={() => save('accepted')}>
            {t('cookie.accept')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent
